export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-pagination@1.17.3@rc-pagination/es/index.js
// module id = 657
// module chunks = 0 1